import { CollapsibleDataGridLayout, List } from 'framework/list';
import { BadgeField, DateField, ListColumnTotalField, PercentField, TextField } from 'framework/ui/field';
import { AssignmentTargetLinkField, PositionInAssignmentField, useAssignmentService } from 'domain/shared/assignment';
import { EmployeeLinkField, useEmployeeUrl } from 'domain/shared/employee';
import { useShowContext } from 'framework/show';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ResourceData } from 'framework/crud';
import { Badge } from 'framework/ui/mui-builder';
import { DATE_FORMAT, useDateService } from 'framework/utils';

const getPercentLabel = (totalPercent: number) => (
  <Typography variant="subtitle1" color="success">
    {totalPercent}%
  </Typography>
);

const PlannedAssignments = () => {
  const { search } = useAssignmentService();
  const { data } = useShowContext();
  const { employeeAlias } = data.getData();
  const { getEmployeeAssignmentsUrl } = useEmployeeUrl();
  const { getToday, formatDate } = useDateService();

  const getAssignmentsDataMethod = async (params: ResourceData) => {
    return search({
      ...params,
      filter: {
        'specification:assignmentsByEmployeeAlias': { eq: employeeAlias },
        from: { le: formatDate(getToday().add(1, 'month'), DATE_FORMAT.API_ONLY_DATE)?.trim() },
        to: { ge: formatDate(getToday().add(2, 'months'), DATE_FORMAT.API_ONLY_DATE)?.trim() },
        ...params.filter,
      },
    });
  };

  return (
    <List getDataMethod={getAssignmentsDataMethod}>
      <Box
        sx={{
          '& .list-general tbody td': { border: 0, fontSize: '12px', p: 1 },
          '& .list-general th': { width: 'auto', p: 1 },
          pb: 2,
        }}
      >
        <CollapsibleDataGridLayout
          buttons={[]}
          isSmallTable
          nonExpandedHeader={
            <Typography variant="h4" color="primary">
              <Link target="_blank" to={getEmployeeAssignmentsUrl(employeeAlias)}>
                Planned assignments (Next month)
              </Link>
            </Typography>
          }
        >
          <BadgeField
            width={280}
            label={
              <Link
                style={{ fontSize: '12px', fontWeight: 'bold', color: 'primary.main' }}
                target="_blank"
                to={getEmployeeAssignmentsUrl(employeeAlias)}
              >
                Planned assignments (Next month)
              </Link>
            }
            source="target.id"
            nameSource="target.displayName"
            typeSource="target.type"
            style={{ display: 'inline-flex' }}
            badges={[
              <Badge key="new" color="success" sx={{ fontSize: '10px' }}>
                New
              </Badge>,
            ]}
          >
            <AssignmentTargetLinkField
              source="target.id"
              nameSource="target.displayName"
              typeSource="target.type"
              serviceCatalogIdSource="target.targetId"
              isOpenInNewTab
            />
          </BadgeField>
          <PercentField
            source="minPercent"
            label={<ListColumnTotalField source="minPercent" value={getPercentLabel} />}
          />
          <TextField label={<Typography color="success">-</Typography>} value="-" />
          <PercentField
            source="maxPercent"
            label={<ListColumnTotalField source="maxPercent" value={getPercentLabel} />}
          />
          <PositionInAssignmentField source="assignmentType" label="" />
          <EmployeeLinkField source="ownerId" nameSource="ownerName" label="" isOpenInNewTab />
          <DateField source="from" label=" " />
          <Typography>-</Typography>
          <DateField source="to" label=" " />
        </CollapsibleDataGridLayout>
      </Box>
    </List>
  );
};

export default PlannedAssignments;
